/**
 * Presentación de la línea de producto en los bloques de carrito y checkout.
 *
 * Esas dos pantallas las pinta React contra la Store API, así que no pasan por
 * ninguna plantilla PHP del theme: lo único que las deja tocar son los filtros
 * que WooCommerce publica en window.wc.blocksCheckout.
 */
(function () {

    const blocksCheckout = window.wc && window.wc.blocksCheckout;

    if (!blocksCheckout || typeof blocksCheckout.registerCheckoutFilters !== 'function') return;

    const labels = window.scCartLineItem || {};

    blocksCheckout.registerCheckoutFilters('santacole', {

        /* El precio que sale bajo el nombre es el unitario, mientras que el de la
           derecha es el total de la línea: sin etiqueta los dos se leen igual y
           con cantidad > 1 parecen contradecirse. El formato tiene que conservar
           el marcador <price/> o WooCommerce descarta el filtro. */
        subtotalPriceFormat: (value) => labels.unitPrice ? labels.unitPrice + ' <price/>' : value,
    });

})();
